export const environment = {
  production: true,
  apiRoot: 'https://fake-prod.indianabgc.org/api'
};
